import { createSlice } from "@reduxjs/toolkit";
//import { createSelector } from "reselect";
import { apiCallBegan } from "./api";
import moment from "moment";



const slice = createSlice({
  name: 'companies',
  initialState: {
    list: [],
    currentCompany: [],
    //currentCompany: null,
    loading: false,
    lastFetch: null,
  },
  reducers: {
    companiesRequested: (companies, action) => {
      companies.loading = true;
    },
    companiesReceived: (companies, action) => {
      companies.list = action.payload;
      companies.loading = false;
      companies.lastFetch = Date.now();
    },
    currentCompanyLoaded: (companies, action) => {
      companies.currentCompany = action.payload;
      companies.loading = false;
    },
    companiesRequestedFailed: (companies, action) => {
      companies.loading = false;
    },
    companyAdded: (companies, action) => {
      companies.list.push(action.payload);
    },
  },
});

export const {
  companyAdded,
  companiesReceived,
  companiesRequested,
  currentCompanyLoaded,
  companiesRequestedFailed,
} = slice.actions;
export default slice.reducer;

// Selectors
export const getCurrentCompany = (state) => state.entities.companies.currentUser;

// Action creators
const url = "/companies";

export const loadCompanies = () => (dispatch, getState) => {
  const { lastFetch } = getState().entities.companies;

  const diffInMinutes = moment().diff(moment(lastFetch), "minutes");

  if (diffInMinutes < 10) return;

  return dispatch(
    apiCallBegan({
      url,
      onStart: companiesRequested.type,
      onSuccess: companiesReceived.type,
      onError: companiesRequestedFailed.type,
    })
  );
};

export const loadCurrentCompany = (id) => (dispatch,getState) => {
  const { lastFetch } = getState().entities.companies;

  const diffInSeconds = moment().diff(moment(lastFetch), "seconds");

  if (diffInSeconds < 20) return;
  return dispatch(
    apiCallBegan({
      url: url + "/" + id,
      onStart: companiesRequested.type,
      onSuccess: currentCompanyLoaded.type,
      onError: companiesRequestedFailed.type,
    })
  );
};



export const addCompany = (company) =>
  apiCallBegan({
    url,
    method: "post",
    data: company,
    onSuccess: companyAdded.type,
  });